import CompactLink from './compact-link'

export const AmuiCompactLink = CompactLink

export default Vue => Vue.component(CompactLink.name, CompactLink)
